import { Component, OnInit } from '@angular/core';
import { AuthProvider } from '../../providers/auth';
import { UserDb } from '../../providers/user';
import { Router } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './app-navbar.component.html',
    styleUrls: ['./app-navbar.component.css']
})
export class AppNavbarComponent implements OnInit {

    userLogged: UserDb = new UserDb();
    admin: boolean = false;

    constructor(public _auth: AuthProvider, public router: Router) {
        this.userLogged = this._auth.userLoggend;
        this.admin = this._auth.userLoggend.role == 'admin';
    }

    logout(){
        this._auth.logout();
        this.router.navigate(['login']);
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/common/app-navbar/app-navbar.component.ts